/**
 * Gets the repositories of the user from Github
 */

import { call, put, select, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import { loginSuccess, setSelectedPolicyId, setFnolReportDateValidation } from 'containers/App/actions';
import { setError, clearError } from 'containers/App/actions';
import apiConfig from 'utils/apiConfig';
import { startProgress, endProgress } from 'containers/ProgressBar/actions';
import {
  makeSelectLoginInfo,
  makeSelectAuthToken,
  makeSelectVerificationCode,
} from './selectors';
import {
  setAuthenticationToken,
  setRequireVerificationCode,
  setUserName,
  loading,
} from './actions';
import { VALIDATE_VERIFICATION_CODE, VALIDATE_POLICY_INFO } from './constants';
import messages from './messages';

/**
 * Github repos request/response handler
 */
function* getReportDateValidationStatus() {
  const token = yield select(makeSelectAuthToken());
  const requestUrl = `${
    apiConfig.restServiceDomain
    }/rest/validationSettings`;
  const requestOption = {
    method: 'GET',
    headers: {
      Authorization: `bearer ${token}`,
    },
  };

  return { requestUrl, requestOption };
}

export function* validateEmailPolicyNumber() {
  const authModel = yield select(makeSelectLoginInfo());
  const requestURL = `${
    apiConfig.restServiceDomain
  }/api/v1/auth/verificationToken`;
  const options = {
    method: 'POST',
    body: JSON.stringify(authModel),
    headers: {
      'Content-Type': 'application/json',
    },
  };
  try {
    yield put(clearError());
    yield put(startProgress());
    yield put(loading(true));
    const response = yield call(request, requestURL, options);
    yield put(setAuthenticationToken(response.token));
    yield put(setRequireVerificationCode(true));
  } catch (err) {
    yield put(setError(messages.loginFail.defaultMessage));
    // yield put(showErrorToastr(messages.loginFail.defaultMessage));
  } finally {
    yield put(endProgress());
    yield put(loading(false));
  }
}

export function* validateVerificationCode() {
  const authModel = yield select(makeSelectLoginInfo());
  const token = yield select(makeSelectAuthToken());
  const verificationCode = yield select(makeSelectVerificationCode());
  const requestURL = `${apiConfig.restServiceDomain}/api/v1/auth/token`;
  const options = {
    method: 'POST',
    body: JSON.stringify(authModel),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `bearer ${token}`,
      'X-Verification-Code': verificationCode,
    },
  };
  const {
    requestUrl: reportDateValidateStatusRequest,
    requestOption: reportDateValidateStatusRequestOption,
  } = yield getReportDateValidationStatus();
  try {
    yield put(clearError());
    yield put(startProgress());
    yield put(loading(true));
    const response = yield call(request, requestURL, options);
    yield put(setAuthenticationToken(response.token));
    yield put(setSelectedPolicyId(response.policyId));
    yield put(setUserName(response.clientName));
    yield put(setRequireVerificationCode(false));
    const reportDateValidationStatus = yield call(request, reportDateValidateStatusRequest, reportDateValidateStatusRequestOption);
    yield put(setFnolReportDateValidation(reportDateValidationStatus.fnolReportDateValidation));
    // set token expired time
    localStorage.setItem('expiredTokenTime', (new Date().getTime() + (response.expiresIn * 1000)).toString());
    yield put(loginSuccess());
  } catch (err) {
    yield put(setError(messages.verificationCodeFail.defaultMessage));
    // yield put(showErrorToastr(messages.verificationCodeFail.defaultMessage));
  } finally {
    yield put(endProgress());
    yield put(loading(false));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function* authenticate() {
  yield takeLatest(VALIDATE_POLICY_INFO, validateEmailPolicyNumber);
  yield takeLatest(VALIDATE_VERIFICATION_CODE, validateVerificationCode);
}



// WEBPACK FOOTER //
// ./app/containers/Login/saga.js